/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_DeleteInputs */

const vi_shop_group_delete = /** @type {(inputs: Shop_Group_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá nhóm`)
};

/**

* @param {Shop_Group_DeleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_delete = /** @type {((inputs?: Shop_Group_DeleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_DeleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_delete(inputs)
});